import { CARDS } from '../../data/cards';
import { LOSS_ENDINGS, WIN_ENDINGS } from '../../data/endings';

const cards = {};
CARDS.forEach((c) => {
  cards[c.id] = {
    title: c.title,
    prompt: c.prompt,
    left: c.left.label,
    right: c.right.label,
  };
});

const endings = {};
[...Object.values(LOSS_ENDINGS), ...WIN_ENDINGS].forEach((e) => {
  endings[e.id] = { title: e.title, line: e.line };
});

const locale = {
  ui: {
    titleEyebrow: 'A card-swipe game',
    titleSub:
      'Your first 90 days as a Product Manager at a mid-size SaaS company. ' +
      "Survive 60 cards. Don't max out, don't bottom out.",
    titleCta: 'Start day one',
    titleBest: 'Best run',
    titleEndings: 'Endings unlocked',
    titleDays: 'days',
    creditsBy: 'thenew.pm — a web-based decision making game by',
    creditsTagline: 'a game where you are the new product manager',
    playHint: 'Swipe, tap, or use ← / →',
    dayLabel: 'Day',
    endingDayLost: 'Day {day} — game over',
    endingDayWon: 'Day 90 — you survived',
    endingRestart: 'New PM, new start',
    endingUnlocked: '{n} of {total} endings unlocked',
  },
  stats: {
    e: { short: 'Eng',    label: 'Engineering trust' },
    x: { short: 'Exec',   label: 'Exec confidence' },
    u: { short: 'Impact', label: 'User impact' },
    p: { short: 'Energy', label: 'Personal energy' },
  },
  roles: {
    engineer:  'Engineering',
    designer:  'Design',
    exec:      'Executive',
    customer:  'Customer',
    sales:     'Sales',
    data:      'Data',
    intern:    'Intern',
    recruiter: 'Recruiting',
  },
  endings,
  cards,
};

export default locale;
